
import { defineComponent, ref, onMounted } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Form',
    },
    data: {
      type: Object,
    },
  },
  setup (props) {
    const formRef = ref()
    const form = ref(props.data)
    const name = ref('Check Status')
    const store = useStore()

    const payment_status_updaters = ref([])

    const filterOption = (
        input: string,
        option: { children: { children: string }[] }
        ) => {
        return (
            option.children[0].children
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
    };
        

    onMounted(() => {
        store.dispatch('PaymentStatusUpdater/index').then((res) => {
            payment_status_updaters.value = res.data.data
        })
    })

    return {
        form,
        formRef,
        name,
        payment_status_updaters,
        filterOption,
    }
  },
})
